module.exports = __webpack_public_path__ + "static/img/info-on-64px.0643cc82.png";